import { Box, Button, Container, Paper } from '@mui/material'
import React from 'react'
import { Helmet } from 'react-helmet'
import JsonView from 'react-json-view'
import { useNavigate } from 'react-router-dom'

import { useMinter } from '../Contexts'
import WorldBasePage from './WorldBasePage'

const JsonPageBody: React.FC = () => {
  const navigate = useNavigate()
  const { minter } = useMinter()
  const json = minter?.toJsonObject() ?? {}
  return (
    <Box padding={2}>
      <Paper>
        <Box bgcolor="white" margin={2} padding={2}>
          <JsonView src={json} />
        </Box>
        <Box display="flex" justifyContent="space-between" margin={1}>
          <Button onClick={() => navigate(-1)}>Back</Button>
        </Box>
      </Paper>
    </Box>
  )
}

const JsonPage: React.FC = () => {
  return (
    <WorldBasePage>
      <Helmet title="Json View" />
      <Container>
        <JsonPageBody />
      </Container>
    </WorldBasePage>
  )
}

export default JsonPage
